import { useMemo } from 'react';
import type { Event } from '../../interfaces/Calendar.model';

interface CalendarLegendProps {
    events: Event[];
}

export function CalendarLegend({ events }: CalendarLegendProps) {
    const types = useMemo(() => {
        const seen = new Set<string>();
        const list: Event['type'][] = [];
        for (const event of events) {
            if (!seen.has(event.type.slug)) {
                seen.add(event.type.slug);
                list.push(event.type);
            }
        }
        return list;
    }, [events]);

    return (
        <div className="flex flex-wrap py-12 pt-0 justify-between items-center">
            <div className="w-full lg:w-10/12 lg:m-auto flex flex-col md:flex-row justify-between px-4 relative pt-12">
                {types.map((type) => (
                    <div key={type.slug} className="flex">
                        <div
                            className="block w-6 h-6 mb-4 lg:mb-0 mr-4"
                            style={{ backgroundColor: type.color }}
                        ></div>
                        <div className="uppercase text-white">= {type.name}</div>
                    </div>
                ))}
            </div>
        </div>
    );
}
